import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import { relTime } from './utils';
/**
 * Homepage discussions block: a Latest / Most-commented switcher above a 2×2
 * grid of compact discussion cards. Owns its own `panel` toggle state; the two
 * pre-loaded lists are passed in by HomePage.
 */
export default class HomeDiscussions extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "panel", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.panel = 'latest';
  }
  view() {
    const rows = this.panel === 'latest' ? this.attrs.latest : this.attrs.commented;
    return m("section", {
      className: "HomeSection"
    }, m("div", {
      className: "container"
    }, m("div", {
      className: "HomeSection-head"
    }, m("div", {
      className: "HomeSwitcher",
      role: "tablist"
    }, m("button", {
      className: 'HomeSwitcher-tab' + (this.panel === 'latest' ? ' active' : ''),
      onclick: () => this.panel = 'latest'
    }, m("i", {
      className: "fas fa-bolt"
    }), " ", app.translator.trans('glowingblue-demo.forum.home.discussions.latest')), m("button", {
      className: 'HomeSwitcher-tab' + (this.panel === 'commented' ? ' active' : ''),
      onclick: () => this.panel = 'commented'
    }, m("i", {
      className: "fas fa-comments"
    }), " ", app.translator.trans('glowingblue-demo.forum.home.discussions.commented'))), m(Link, {
      href: app.route('index'),
      className: "HomeSection-more"
    }, app.translator.trans('glowingblue-demo.forum.home.discussions.view_all'), " ", m("i", {
      className: "fas fa-arrow-right"
    }))), m("div", {
      className: "HomeDiscussions"
    }, rows.length ? rows.map(d => this.card(d)) : m("p", {
      className: "HomeEmpty"
    }, app.translator.trans('glowingblue-demo.forum.home.discussions.empty')))));
  }
  card(discussion) {
    var _discussion$user, _discussion$lastPoste, _discussion$lastPoste2, _discussion$unreadCou, _discussion$commentCo, _discussion$commentCo2;
    const user = (_discussion$user = discussion.user) == null ? void 0 : _discussion$user.call(discussion);
    const lastUser = ((_discussion$lastPoste = discussion.lastPostedUser) == null ? void 0 : _discussion$lastPoste.call(discussion)) || user;
    // tags() can throw or be undefined if the relationship isn't loaded.
    let tags = [];
    try {
      var _tags, _ref;
      tags = ((_tags = (_ref = discussion).tags) == null ? void 0 : _tags.call(_ref)) || [];
    } catch (_unused) {
      tags = [];
    }
    return m(Link, {
      href: app.route.discussion(discussion),
      className: "HomeDcard",
      key: discussion.id()
    }, m("span", {
      className: "HomeDcard-avatar"
    }, lastUser ? Avatar.component({
      user: lastUser
    }) : m("span", {
      className: "Avatar"
    })), m("div", {
      className: "HomeDcard-main"
    }, m("div", {
      className: "HomeDcard-title"
    }, discussion.title()), m("div", {
      className: "HomeDcard-meta"
    }, tags.slice(0, 2).map(tag => this.tagChip(tag)), m("span", {
      className: "HomeDcard-by"
    }, lastUser && lastUser.displayName() || app.translator.trans('glowingblue-demo.forum.home.discussions.someone'), ((_discussion$lastPoste2 = discussion.lastPostedAt) == null ? void 0 : _discussion$lastPoste2.call(discussion)) && ' · ' + relTime(discussion.lastPostedAt())))), m("div", {
      className: "HomeDcard-counts"
    }, m("span", {
      className: (_discussion$unreadCou = discussion.unreadCount) != null && _discussion$unreadCou.call(discussion) ? 'unread' : ''
    }, m("i", {
      className: "far fa-comment"
    }), " ", (_discussion$commentCo = (_discussion$commentCo2 = discussion.commentCount) == null ? void 0 : _discussion$commentCo2.call(discussion)) != null ? _discussion$commentCo : 0)));
  }
  tagChip(tag) {
    const color = tag.color() || 'var(--be-slate-muted)';
    return m("span", {
      className: "HomeChip",
      style: {
        '--c': color
      }
    }, tag.icon() && m("i", {
      className: tag.icon()
    }), " ", tag.name());
  }
}
flarum.reg.add('glowingblue-demo', 'forum/components/home/HomeDiscussions', HomeDiscussions);